import React from 'react';
import './App.scss';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PageComponent from './pages';
import CampaignDonation from './pages/campaign-donation/campaign-donation';
import RegionDonation from './pages/region-donation/region-donation';
import RegionTotal from './pages/region-total/region-total';
import CampaignTotal from './pages/campaign-total/campaign-total';
import PartnerTotal from './pages/partner-total/partner-total';
import PartnerDonation from './pages/partner-donation/partner-donation';

const queryClient = new QueryClient();

const Dashboard = () => {
  return <Outlet />;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <div className="app-container">
            <Routes>
              <Route element={<Dashboard />} path="/" key="DashboardPage">
                <Route path="/v1/regions/last-donation" element={<PageComponent component={RegionDonation} title="Last Donation" />} />
                <Route path="/v1/campaigns/last-donation" element={<PageComponent component={CampaignDonation} title="Last Donation" />} />
                <Route path="/v1/partners/last-donation" element={<PageComponent component={PartnerDonation} title="Last Donation" />} />
                <Route path="/v1/regions/total" element={<PageComponent component={RegionTotal} title="Total" />} />
                <Route path="/v1/campaigns/total" element={<PageComponent component={CampaignTotal} title="Total" />} />
                <Route path="/v1/partners/total" element={<PageComponent component={PartnerTotal} title="Total" />} />
              </Route>
            </Routes>
          </div>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
